import { Stack, Typography } from "@material-ui/core";
import { parsePhoneNumber } from "utils/Haim/phoneNumbersUtils";
import type { RealEstateContact } from "../../../../../@types/sharedSchema";

type ContactPhoneNumberProps = {
  bold?: boolean;
  contact: Partial<RealEstateContact>;
};

export function ContactTablePhoneNumber({ bold, contact }: ContactPhoneNumberProps) {
  // The document id IS the phone. `contactId` is the Cloud-Function-stamped copy of it,
  // and covers the synthesized contact-shaped objects some callers build from a CRM row.
  // `callerPhoneNumber` is deliberately not consulted — absent on ~90% of documents.
  const phone = contact.id ?? contact.contactId;

  const parsedPhoneNumber = parsePhoneNumber(phone);

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      {parsedPhoneNumber && (
        <img
          width={bold ? 24 : 20}
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${parsedPhoneNumber.country}.svg`}
          alt={parsedPhoneNumber.country}
        />
      )}
      <Typography noWrap {...(bold && { variant: "h6" })}>
        {parsedPhoneNumber?.formatNational() ?? phone}
      </Typography>
    </Stack>
  );
}
